import { Eyebrow } from "../components/ui-bits";

const DOCS = {
  privacy: {
    title: "Privacy Policy",
    intro: "How Verde Capital collects, uses and protects your information.",
    sections: [
      { h: "Information we collect", p: ["When you submit a project, deal, contact message or expert application, we collect the information you provide: contact details, company information, and details about your project or enquiry."] },
      { h: "How we use it", p: ["We use your information to evaluate and process submissions, respond to enquiries, and communicate with you about Verde Capital's services. We do not sell your personal information."] },
      { h: "Sharing", p: ["Information may be shared with the Verde Capital Expert Network and professional advisers strictly as needed to evaluate a submission, and always under confidentiality expectations."] },
      { h: "Your rights", p: ["You may request access to, correction of, or deletion of your personal information by contacting us."] },
    ],
  },
  cookies: {
    title: "Cookies Policy",
    intro: "How this website uses cookies and similar technologies.",
    sections: [
      { h: "What we use", p: ["This website uses only essential functionality cookies and privacy-preserving analytics. No advertising cookies are set."] },
      { h: "Managing cookies", p: ["You can control or delete cookies through your browser settings. Restricting cookies may affect parts of the website's functionality."] },
    ],
  },
  terms: {
    title: "Terms of Use",
    intro: "The terms that apply when using this website.",
    sections: [
      { h: "Use of this website", p: ["This website is provided for information purposes. By using it, you agree to these terms."] },
      { h: "No offer of financing", p: ["Nothing on this website constitutes an offer of financing, a credit decision, or an invitation to apply for credit. All financing is subject to underwriting, due diligence and documentation."] },
      { h: "Intellectual property", p: ["The content, design and branding of this website belong to Verde Capital and may not be reproduced without permission."] },
    ],
  },
  lending: {
    title: "Lending Disclaimer",
    intro: "Important information about the nature of Verde Capital's financing.",
    sections: [
      { h: "Indicative terms", p: ["Any terms provided by Verde Capital, whether through this website or otherwise, are indicative only and do not constitute an offer of credit, a commitment to lend, or a credit decision."] },
      { h: "No automated decisions", p: ["Verde Capital does not make automated credit decisions. Every submission is reviewed by Verde Capital's credit team, with input from relevant experts where appropriate."] },
      { h: "Scope", p: ["Verde Capital provides short-term senior secured financing, typically €1–5M, to experienced real estate developers for projects in Portugal. Financing is subject to due diligence, valuation, legal review and documentation."] },
    ],
  },
};

export default function Legal({ doc }) {
  const d = DOCS[doc] || DOCS.privacy;
  return (
    <div className="min-h-screen bg-cream">
      <section className="pt-32 sm:pt-40 pb-8">
        <div className="container-x max-w-3xl">
          <Eyebrow>Legal</Eyebrow>
          <h1 className="display mt-6 text-4xl sm:text-5xl text-charcoal" data-testid="page-headline">
            {d.title}
          </h1>
          <p className="mt-5 text-fog">{d.intro}</p>
        </div>
      </section>
      <section className="pb-28">
        <div className="container-x max-w-3xl">
          <div className="border-t border-sand">
            {d.sections.map((s) => (
              <div key={s.h} className="border-b border-sand py-8" data-testid={`legal-${s.h.toLowerCase().replace(/\s+/g, "-")}`}>
                <h2 className="font-display text-xl font-bold text-charcoal">{s.h}</h2>
                {s.p.map((para, i) => (
                  <p key={i} className="mt-4 text-ink leading-relaxed">{para}</p>
                ))}
              </div>
            ))}
          </div>
          <p className="mt-8 text-xs text-fog">Last updated: {new Date().toLocaleDateString("en-GB", { month: "long", year: "numeric" })}</p>
        </div>
      </section>
    </div>
  );
}
